import React from 'react';
import classnames from 'classnames';
import {ErrorMessage} from 'formik';
import _get from 'lodash/get';

export default function InputBox({
  style,
  postfix,
  field,
  form: {touched, errors, setFieldValue},
  showError = false,
  decimalPlaces,
  ...props
}) {
  const handleBlur = e => {
    field.onBlur(e);
    if (decimalPlaces != null && e.target.value !== '') {
      const parsed = parseFloat(e.target.value);
      if (Number.isFinite(parsed)) {
        setFieldValue(field.name, parsed.toFixed(decimalPlaces));
      }
    }
  };

  return (
    <>
      <div className="d-flex">
        <input
          {...props}
          {...field}
          {...(decimalPlaces != null && {onBlur: handleBlur})}
          value={_get(field, 'value', '')}
          className={classnames({
            'form-control': true,
            'is-invalid': _get(touched, field.name) && _get(errors, field.name),
          })}
          style={style && style}
        />
        {postfix && (
          <span className="kt-margin-t-10 kt-margin-l-5">{postfix}</span>
        )}
      </div>
      <span
        className={classnames({
          'invalid-feedback': !showError,
        })}
        style={{color: '#fd397a'}}
      >
        <ErrorMessage name={field.name} />
      </span>
    </>
  );
}
